export default __webpack_public_path__ + "static/media/logo-24-ic-hotels.1efdd870.png";